export enum LogLevel {
	Debug = 'debug',
	Info = 'info',
	Log = 'log',
	Warn = 'warn',
	Error = 'error',
}

export enum LoggerEnvironment {
	Dev = 'development',
	Stage = 'staging',
	Prod = 'production',
}
